<div class="loader-wrapper " style="background-color: #ffffffd4; left: 0px;">
    <span class="loader"></span>
  </div>
  
